export default "__VITE_ASSET__d0df31e7__"